import ModuleContainer from 'components/common/ModuleContainer';
import ModuleHeader from 'components/common/ModuleHeader';
import { SearchDetailPage } from './SearchDetailPage/SearchDetailPage';

/**
 * Renders a page providing search functionality
 * user can search using case, account or patient info
 * search results are rendered once search term is submitted via {@link SearchDetailPage}
 * search results can be narrowed using various filters available like case status, case, account etc.,
 *
 * @see SearchDetailPage
 */
const SearchLookupPage: React.FC = () => {
  return (
    <ModuleContainer>
      <ModuleHeader title="Search" />
      <SearchDetailPage />
    </ModuleContainer>
  );
};

export default SearchLookupPage;
